import React from "react";

import classes from "./Button.module.css";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({ children, ...props }) => {
  return (
    <button
      {...props}
      className={`${props.className} ${classes.button} 
                h-[56px] rounded-full uppercase flex items-center font-bebasneue font-medium text-[20px] leading-[110%] tracking-[0.25px] hover:cursor-pointer
                
                xl:bg-transparent xl:text-[#008fd2] xl:h-[38px]
                
                bg-white text-primary
                enabled:hover:bg-primary enabled:hover:text-white transition-all duration-300
                relative
                
                disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed
                
                pl-16 pr-5 enabled:hover:pl-5 enabled:hover:pr-16
                xl:pl-12 xl:pr-5 enabled:hover:xl:pl-5 enabled:hover:xl:pr-12
            `}
    >
      <div
        className={`
          ${classes.icon} rounded-full text-white bg-primary flex items-center justify-center
          
          w-12 h-12 xl:w-[30px] xl:h-[30px] 
          
          transition-all duration-300
          absolute left-1
        `}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          className="w-5 h-5 absolute"
        >
          <path
            d="M2.9 10H17m.1 0L10 2.9m7.1 7.1L10 17.1"
            style={{
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "2px",
            }}
          />
        </svg>
      </div>

      {children}
    </button>
  );
};

export default Button;
